module.exports = __webpack_public_path__ + "img/CCWhitewithTopBox.38820b4b.png";